import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GridBaseComponent } from '../../../../../base/shared/grid-base/grid-base.component';
import { CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ClientService } from '../../../../../base/services/client/client.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ClientDTO, ControlPlateType, ParkerTagDTO } from '../../../../../base/models/models.swagger.generated';
import { TagType } from '../edit-parker-edit-tag-list-form/tag-type.enum';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { EditParkerEditTagListFormComponent } from '../edit-parker-edit-tag-list-form/edit-parker-edit-tag-list-form.component';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { EditParkerEditTagListFormType } from '../edit-parker-edit-tag-list-form/edit-parker-edit-tag-list-form.type';

@Component({
    selector: 'app-edit-parker-tags-list',
    templateUrl: './edit-parker-tags-list.component.html',
    styleUrls: ['./edit-parker-tags-list.component.scss'],
    standalone: true,
    imports: [GridModule, ToolbarModule, EditParkerEditTagListFormComponent, TranslateModule]
})
export class EditParkerTagsListComponent extends GridBaseComponent implements OnInit {

  @Input() public client: ClientDTO;
  @Input() public tags: ParkerTagDTO[];
  @Output() public tagsChange = new EventEmitter<ParkerTagDTO[]>();

  public commands: CommandModel[] = GridConstantsFactory.createStandardGridCommands();
  private newItemIndexCount = -1;

  constructor(translateService: TranslateService,
              clientService: ClientService,
              private fb: FormBuilder) {
    super(clientService, translateService, null);
  }

  public ngOnInit(): void {
    this.isActiveColumnName = 'active';
    this.editDialogTitle = 'i18n.domain.parker-administration.edit-tag';
    this.addDialogTitle = 'i18n.domain.parker-administration.add-tag';
    this.addIndexFindColumnName = 'Id';
  }

  public override actionComplete(args) {
    super.actionComplete(args);
    this.tagsChange.emit(this.tags);
  }

  public formatControlPlateType(data): string {
    return 'i18n.shared.controlPlateType.' + ControlPlateType[data.controlPlateType];
  }

  protected initializeEditForm(data: ParkerTagDTO): void {
    let barcode = data.barcode;
    const barcodeSplit = data.barcode?.split('.');
    if (barcodeSplit && barcodeSplit.length > 2) {
      barcode = barcodeSplit[2];
    }
    this.gridEditForm = this.fb.group<EditParkerEditTagListFormType>({
      id: this.fb.control(data.id || 0),
      identificationCode: this.fb.control({value: data.identificationCode, disabled: true}),
      barcode: this.fb.control(barcode),
      clientIdent: this.fb.control({value: this.clientService.selectedClient.clientIdent, disabled: true}, [Validators.required]),
      tagType: this.fb.control({value: TagType[TagType.Parker].toString(), disabled: true}, [Validators.required]),
      countryCode: this.fb.control(data.countryCode || 'CH', [Validators.required]),
      controlPlateType: this.fb.control(data.controlPlateType),
      controlPlateNumber: this.fb.control(data.controlPlateNumber, [Validators.maxLength(10)]),
      description: this.fb.control(data.description),
      active: this.fb.control(data.active ?? true),
      defect: this.fb.control(data.defect ?? false),
      clientId: this.fb.control(this.client.id),
      parkerId: this.fb.control(data.parkerId || 0),
      modifiedBy: this.fb.control({value: data.modifiedBy, disabled: true}),
      modifiedOn: this.fb.control({value: data.modifiedOn ? data.modifiedOn.toFormat('dd.MM.yyyy HH:mm:ss') : "", disabled: true}),
    });
  }

  protected getEditDialogTitleParams(rowData: any): any {
    return {params: ''};
  }

  protected override getDataToSave(): any {
    const data = this.gridEditForm.getRawValue();
    if (data.id === 0) {
      data.id = this.newItemIndexCount;
      this.newItemIndexCount = this.newItemIndexCount - 1;
    }
    if (data.barcode == '') {
      data.barcode = null;
    }
    if (data.barcode != null) {
      data.barcode = data.clientIdent + '.' + data.tagType + '.' + data.barcode;
    }
    return data;
  }
}
